import { Role } from '@/enums/roles.ts'
import i18n from '@/libs/i18n'
import type { NavLink } from '@/types/Navigation'

const { t } = i18n.global

export const getNavItems = (): NavLink[] => {
    return [
        {
            items: [
                { label: t('general.dashboard'), icon: 'pi pi-fw pi-chart-bar', to: 'dashboard' },
                { label: t('customer.customer', 2), icon: 'pi pi-fw customer-icon', to: 'customers', requiredRoles: [Role.ADMIN, Role.USER] },
                { label: t('calendar.calendar'), icon: 'pi pi-fw calendar-icon', to: 'calendar', requiredRoles: [Role.ADMIN, Role.USER] },
                { label: t('customer.customers_without_added_users'), icon: 'pi pi-fw user-x-icon', to: 'customers-without-added-users', requiredRoles: [Role.ADMIN, Role.USER] },
                { label: t('equipment_procurement.equipment_procurement'), icon: 'pi pi-fw warehouse-icon', to: 'equipment-procurements', requiredRoles: [Role.ADMIN] },
                { label: t('user.user', 2), icon: 'pi pi-fw pi-users', to: 'users', requiredRoles: [Role.ADMIN] },
                { label: t('equipment.additional_equipment', 2), icon: 'pi pi-fw screen-icon', to: 'additional-equipments', requiredRoles: [Role.ADMIN] },
                { label: t('equipment.card_payment_equipment', 2), icon: 'pi pi-fw pos-terminal-icon', to: 'card-payment-equipments', requiredRoles: [Role.ADMIN] },
                { label: t('current_program.current_program', 2), icon: 'pi pi-fw chip-icon', to: 'current-programs', requiredRoles: [Role.ADMIN] }
            ]
        }
    ]
}
